import { AlertTriangle } from 'lucide-react';
import { Modale } from '../ui/Modale';
import { BoutonSecondaire } from '../ui/Primitives';

/**
 * Confirmation d'une décision irréversible.
 *
 * Remplace le `confirm()` natif, proscrit sur le projet : il ne suit pas la
 * charte, ne se ferme pas au clavier comme le reste de l'application, et sur
 * mobile il s'affiche en haut de l'écran, loin du bouton qui l'a déclenché.
 */
export function ModaleConfirmation({
  ouverte,
  titre,
  message,
  libelleConfirmer,
  enCours,
  onConfirmer,
  onAnnuler,
}: {
  ouverte: boolean;
  titre: string;
  message: string;
  libelleConfirmer: string;
  enCours?: boolean;
  onConfirmer: () => void;
  onAnnuler: () => void;
}): JSX.Element | null {
  if (!ouverte) return null;

  return (
    <Modale titre={titre} ouverte onFermer={onAnnuler} largeur="max-w-lg">
      <div className="space-y-5 p-4 sm:p-6">
        <p className="flex items-start gap-3 rounded-xl bg-amber-50 p-4 text-sm text-amber-900">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          {message}
        </p>
        <div className="flex flex-wrap items-center justify-end gap-3">
          <BoutonSecondaire onClick={onAnnuler} disabled={enCours}>
            Annuler
          </BoutonSecondaire>
          <button
            type="button"
            onClick={onConfirmer}
            disabled={enCours}
            className="rounded-xl bg-rose-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {enCours ? 'Enregistrement…' : libelleConfirmer}
          </button>
        </div>
      </div>
    </Modale>
  );
}
